import React, { useEffect } from 'react';
import { DashboardTour } from 'Common/Components/Contextualization/Tour';
import DashboardLayout from '../DashboardLayout';
import { useDispatch } from 'react-redux';
import { resetFilters, clearFilters } from 'store/Filters/actions';

const DashboardContext = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      dispatch(clearFilters('vulns'));
      dispatch(clearFilters('assets'));
      dispatch(clearFilters('vulnsAssets'));
      dispatch(resetFilters('dashboard'));
    };
  }, []);
  return (
    <>
      <DashboardLayout />
      <DashboardTour />
    </>
  );
};
export default DashboardContext;
